import {Subscription} from "rxjs";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {environment} from "@numizmat/environments";
import {AdCardMiniComponent, AdCardMiniData} from "@numizmat/components";
import {PublicAdDetailResponse, UserAdLastVisitResponse} from "@numizmat/services-models/core";
import {AdDetailStateService} from "@numizmat/services/core/ad-detail/ad-detail-state.service";
import {UserAdLastVisitApiService, UserAdLastVisitStateService} from "@numizmat/services/core";

@Component({
    selector: 'nz-last-visited-ads-section',
    imports: [
        AdCardMiniComponent
    ],
    templateUrl: './last-visited-ads-section.component.html',
    styleUrl: './last-visited-ads-section.component.scss'
})
export class LastVisitedAdsSectionComponent implements OnInit, OnDestroy {
  private adDetailStateService: AdDetailStateService = inject(AdDetailStateService);
  private userAdLastVisitApiService: UserAdLastVisitApiService = inject(UserAdLastVisitApiService);
  private userAdLastVisitStateService: UserAdLastVisitStateService = inject(UserAdLastVisitStateService);

  private subs: Subscription = new Subscription();

  protected adId?: string;
  protected lastVisitedAds: AdCardMiniData[] = [];

  public ngOnInit(): void {
    this.getAllLastVisits();
    this.getPublicAdDetails();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getAllLastVisits(): void {
    const subscription: Subscription = this.userAdLastVisitStateService.getAllLastVisits().subscribe({
      next: allLastVisits => {
        if (!!allLastVisits && !!this.adId) {
          this.lastVisitedAds = allLastVisits
            .filter(x => x.adId !== this.adId)
            .map(visit => {
              return {
                adId: visit.adId,
                title: visit.title,
                price: visit.price,
                adType: visit.adType,
                imageUrl: `${environment.apiImageAdUrl}/main/${visit.adId}`,
              }
            }).slice(0, 6);
        }
      }
    });
    this.subs.add(subscription);
  }

  private getPublicAdDetails(): void {
    const subscription: Subscription = this.adDetailStateService.getPublicAdDetails().subscribe({
      next: (adDetails: PublicAdDetailResponse | undefined) => {
        if (!!adDetails) {
          this.adId = adDetails.adId;
          const currentAdVisit: UserAdLastVisitResponse = {
            adId: adDetails.adId,
            title: adDetails.title,
            price: adDetails.price,
            adType: adDetails.adType
          };
          if (!this.userAdLastVisitStateService.isVisitsLoaded) {
            this.userAdLastVisitApiService.getAllLastVisits().subscribe({
              next: response => {
                this.userAdLastVisitStateService.isVisitsLoaded = true;
                this.userAdLastVisitStateService.setAllLastVisits(response);
                this.userAdLastVisitStateService.addLastVisit(currentAdVisit);
              }
            });
          } else {
            this.userAdLastVisitStateService.addLastVisit(currentAdVisit);
          }
        }
      }
    });
    this.subs.add(subscription);
  }
}
